import { type Configuration, LogLevel, type RedirectRequest } from "@azure/msal-browser";
import type { RuntimeConfig } from "@/config/runtime";

export function buildMsalConfig(config: RuntimeConfig): Configuration {
  return {
    auth: {
      clientId: config.azureClientId,
      authority: `https://login.microsoftonline.com/${config.azureTenantId}`,
      // MSAL v5: must be the redirect bridge page (src/redirect.html), and
      // must be registered as a SPA redirect URI on the Entra app.
      redirectUri: config.azureRedirectUri,
      postLogoutRedirectUri: globalThis.location.origin,
    },
    cache: {
      cacheLocation: "localStorage",
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
        loggerCallback: (level, message) => {
          if (level === LogLevel.Error) console.error("[MSAL]", message);
          else if (level === LogLevel.Warning) console.warn("[MSAL]", message);
        },
      },
    },
  };
}

/**
 * Login scopes: who the person is, nothing more. Microsoft 365 access comes from the permissions the organization
 * granted the App Registration (admin consent): the backend's On-Behalf-Of exchange asks for whatever was granted
 * (`.default`) and offers only what that covers. So signing in never asks anyone to approve permissions, and a
 * permission the organization chose not to grant never blocks sign-in. Mirrors frontend/src/config/msal.ts.
 */
export function buildLoginRequest(_config: RuntimeConfig): RedirectRequest {
  return { scopes: ["openid", "profile", "email"] };
}

/** Scope for calling our backend API. Empty when not configured. */
export function buildApiScopes(config: RuntimeConfig): string[] {
  return config.apiScope ? [config.apiScope] : [];
}
